import React from 'react';
import PropTypes from 'prop-types';

const ClaimState = ({ data }) => {
  let displayText = "";
  switch (data){
    case 0:
      displayText = "0 - Í vinnslu";
      break;
    case 1:
      displayText = "1 - Frágengið";
      break;
    case 2:
      displayText = "2 - Hafnað";
      break;
    case 4:
      displayText = "4 - Villa";
      break;
    case 11:
      displayText = "11 - Senda bréf";
      break;
    case 12:
      displayText = "12 - Bréf sent, í bið";
      break;
    case 20:
      displayText = "20 - Skráð";
      break;
    case 30:
      displayText = "30 - Afskráð";
      break;
     default:
      displayText = "Unknown";
       break;
  }
  return (
    <span>{displayText}</span>
  );
};

ClaimState.propTypes = {
  data: PropTypes.number,
};

export default ClaimState;



// WEBPACK FOOTER //
// ./src/pages/ClaimTracker/Display/ClaimState.js